import {szBankStorage} from '../../../util/Function/szBankStorage.js'
export function getdata(){
	var obj = {
		searchdata: {
			nsrmc: "",
			year: szBankStorage.$getNowYear(),
			project: "",
			cycle: "",
			shuikssq:[]
		},
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "select",
				selectval:szBankStorage.$getdemoCompany
			},
			{
				prop: "year",
				label: '年度',
				type: "select",
				selectval:szBankStorage.$getYearList()
			},
			{
				prop: "project",
				label: '项目',
				type: "select",
				selectval:szBankStorage.$projectlist
			},
			{
				prop: "cycle",
				label: '周期',
				type: "select",
				selectval:szBankStorage.$cyclelist
			},
			{
				prop: "shuikssq",
				label: '税款所属期起止',
				type: "date",
				valueformat:"yyyyMMdd"
			},
		],
		tableData:[{
			project:'',
			ProjectD:'',
			cycle:'',
			shuikssqq:'',
			shuikssqz:'',
			AmountC:'',
			TaxAmount:'',
			IncreaseA:'',
			DecreaseA:'',
			prop1:'',
			prop2:'',
			prop3:'',
			updata:false,
			sbbm:'',
		}],
		headData: [{
				title: "序号",
				prop: "Serial",
				custom: true,
				width: 60,
			},
			{
				title: "项目",
				prop: "project",
				width: 160,
				custom: true
			},
			{
				title: "项目详情",
				prop: "ProjectD",
				width: 220,
				custom: true,
			},
			{
				title: "周期",
				prop: "cycle",
				custom: true,
				width: 130,
			},
			{
				title: "数款所属期起",
				prop: "shuikssqq",
				width: 150,
				custom: true
			},{
				title: "税款所属期止",
				prop: "shuikssqz",
				width: 150,
				custom: true
			},{
				title: "账载金额",
				prop: "AmountC",
				custom: true,
				align:"right",
				width: 130,
			},{
				title: "税收金额",
				prop: "TaxAmount",
				custom: true,
				align:"right",
				width: 130,
			},{
				title: "调增金额",
				prop: "IncreaseA",
				align:"right",
				custom: true,
				width: 130,
			},{
				title: "调减金额",
				prop: "DecreaseA",
				align:"right",
				custom: true,
				width: 130,
			},{
				title: "扩展字段1",
				prop: "prop1",
				custom: true,
				width: 130,
			},{
				title: "扩展字段2",
				prop: "prop2",
				custom: true,
				width: 130,
			},{
				title: "扩展字段3",
				prop: "prop3",
				custom: true,
				width: 130,
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				custom: true,
				fixed:"right"
			},
		],
	}
	return obj
}
